export const supportedLocales = ['en', 'ro', 'el', 'it', 'de', 'fr', 'es'] as const;
export const defaultLocale = 'en';

export type SupportedLocale = (typeof supportedLocales)[number];
